import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';
import { connect } from 'react-redux';
import {
  initialise as initialiseAction,
  toggle as toggleAction,
} from './modules';

// istanbul ignore next
class Accordion extends React.PureComponent {
  constructor(props) {
    super(props);

    this.id = uuid();
    this.initialise();
  }

  componentDidUpdate(prevProps) {
    const prevNoOfChildren = R.path(['children', 'length'], prevProps);
    const currentNoOfChildren = R.path(['children', 'length'], this.props);
    if (prevNoOfChildren !== currentNoOfChildren) {
      this.initialise();
    }
  }

  initialise() {
    const { initialise, children, isOpen = false } = this.props;

    this.childKeys = React.Children.toArray(children).map(() => uuid());

    initialise(this.id, this.childKeys.length, isOpen);
  }

  render() {
    const { children, toggle } = this.props;
    return (
      <div className="accordion" role="tablist" aria-multiselectable="true">
        {React.Children.toArray(children).map((child, index) =>
          React.cloneElement(child, {
            key: this.childKeys[index],
            id: this.id,
            index,
            toggle,
          }))}
      </div>
    );
  }
}

Accordion.propTypes = {
  initialise: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
};

const mapStateToProps = undefined;

const mapDispatchToProps = dispatch => ({
  initialise: (id, items, isOpen) =>
    dispatch(initialiseAction(id, items, isOpen)),
  toggle: (id, index) => dispatch(toggleAction(id, index)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Accordion);
